// TODO: Remove from `core-js@4`
require('./es.promise.all-settled.js');



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/modules/esnext.promise.all-settled.js
// module id = 1129
// module chunks = 1